export default "__VITE_ASSET__DNtcWExQ__"